import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=153dc3e2&scoped=true&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=153dc3e2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153dc3e2",
  null
  
)

export default component.exports
import {QDialog,QSpinnerDots,QCard,QCardSection,QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QSpinnerDots,QCard,QCardSection,QInput,QBtn})
